import {
	Button,
	Popover,
	PopoverBody,
	PopoverContent,
	Text,
	PopoverTrigger,
	Stack,
} from '@chakra-ui/react';
import { mdiInformationOutline } from '@mdi/js';
import { createTransfer } from '../../../../../@xmcloud/core/messages/en';
import { t } from '@transifex/native';
import { MergeStrategiesData } from '../../../contenttransfer/handlers';
import { useState } from 'react';
import { Icon } from '../../../../shared-components';

const { mergeStrategiesStepPopoverTitle } = createTransfer;

export const MergeStrategiesPopover = () => {
	const [showPopover, setShowPopover] = useState(false);

	return (
		<Popover
			isOpen={showPopover}
			onOpen={() => setShowPopover(true)}
			onClose={() => setShowPopover(false)}
			placement="bottom-start"
			trigger="hover"
			openDelay={0}
			closeDelay={150}
			closeOnBlur
			closeOnEsc
		>
			<PopoverTrigger>
				<Button
					type="button"
					variant="unstyled"
					display="inline-flex"
					alignItems="center"
					justifyContent="center"
					p={0}
					my={2}
					minW="unset"
					h="auto"
					aria-label={t(mergeStrategiesStepPopoverTitle)}
				>
					<Icon
						path={mdiInformationOutline}
						boxSize={5}
						color="neutral"
					/>
				</Button>
			</PopoverTrigger>
			<PopoverContent w="md">
				<PopoverBody p={3}>
					<Text variant="large" fontWeight="semibold" mb={4}>
						{t(mergeStrategiesStepPopoverTitle)}
					</Text>
					<Stack>
						{MergeStrategiesData.map(({ label, desc }, index) => (
							<Text
								fontWeight="semibold"
								key={`${label}-${index}`}
							>
								{t(label)}
								<Text
									as="span"
									variant="subtle"
									key={`inner-${label}-${index}`}
								>
									{t(desc)}
								</Text>
							</Text>
						))}
					</Stack>
				</PopoverBody>
			</PopoverContent>
		</Popover>
	);
};
